import {screenXs, screenSm, screenLg} from '../../utils/medias';

Hop.defineModule('c-carousel-testimonials', (root, param) => {
    const classCarousel = 'c-carousel-testimonials';
    const classCarouselNavigation = 'm-indicators';
    const classCarouselNavigationDot = `${classCarouselNavigation}__dot`;
    const classCarouselNavigationDotActive = `${classCarouselNavigationDot}_active`;

    const $carousel = root.querySelector(`.${classCarousel}__container`);
    const $carouselContent = root.querySelector(`.${classCarousel}__content`);
    const $navigators = root.querySelectorAll(`.${classCarouselNavigationDot}`);

    const $containerPicture = root.querySelector('.c-carousel-testimonials__picture');
    const $picture = root.querySelector('.c-carousel-testimonials__picture_item');

    const $containerText = root.querySelectorAll('.c-carousel-testimonials__content');

    const size = $navigators.length;

    let idx = 0;
    let timer = null;

    function autoPlay() {
        if (idx + 1 === size) {
            idx = 0;
        } else {
            idx += 1;
        }

        actionOnFeedbacksSlide('right');
    }

    function bindNavigation() {
        $navigators.forEach(($navigator) => {
            $navigator.addEventListener('click', handleSlide);
        });
    }

    function unbindNavigation() {
        $navigators.forEach(($navigator) => {
            $navigator.removeEventListener('click', handleSlide);
        });
    }

    function handleSlide(event) {
        resetInterval();

        const newIdx = parseInt(event.target.dataset.index);
        const side = newIdx < idx ? 'left' : 'right';
        idx = newIdx;
        actionOnFeedbacksSlide(side);
    }

    function refreshActiveDot() {
        $navigators.forEach(($navigator, index) => {
            $navigator.classList.toggle(classCarouselNavigationDotActive, index === idx);
        });
    }

    // Functions setting
    function animationSlideRight(oneContent) {
        oneContent.classList.remove('animateLeft');
        oneContent.classList.add('animateRight');
    }

    function animationSlideLeft(oneContent) {
        oneContent.classList.remove('animateRight');
        oneContent.classList.add('animateLeft');
    }

    function removingAllAnimations(oneContent) {
        oneContent.classList.remove('animateLeft');
        oneContent.classList.remove('animateRight');
        oneContent.classList.add('no-opacity-animation');
    }

    function actionOnSlidePicture(idx) {
        // Compute width transition.
        const slideWidth = $picture.offsetWidth * idx;

        // And transition!
        $containerPicture.style.transform = `translateX(-${slideWidth}px)`;
    }

    function actionOnSlideText(idx, direction) {
        $containerText.forEach((oneContent, index) => {
            oneContent.classList.remove('no-opacity-animation');

            if (index === idx) {
                if (direction === 'right') {
                    animationSlideRight(oneContent);
                } else if (direction === 'left') {
                    animationSlideLeft(oneContent);
                }
            } else {
                removingAllAnimations(oneContent);
            }
        });
    }

    function actionOnFeedbacksSlide(side) {
        refreshActiveDot();
        actionOnSlidePicture(idx);
        actionOnSlideText(idx, side);

        // Fix styles during transition.
        $containerPicture.style.transition = 'transform .5s ease-in';
    }

    function refreshHeightOfCarousel() {
        if (screenLg('min')) {
            $carousel.style.minHeight = '';
            return;
        }

        if (screenSm('min') && screenLg()) {
            $carousel.style.minHeight = $carouselContent.clientHeight + 'px';
        } else if (screenXs()) {
            $carousel.style.minHeight = 450 + $carouselContent.clientHeight + 'px';
        }
    }

    function allowTransition() {
        $containerPicture.style.transition = 'transform .5s ease-in';
    }

    function bindResize() {
        window.addEventListener('resize', refreshHeightOfCarousel, {passive: true});
    }

    function unbindResize() {
        window.removeEventListener('resize', refreshHeightOfCarousel);
    }

    function bindTransition() {
        $containerPicture.addEventListener('transitionend', allowTransition, false);
    }

    function unbindTransition() {
        $containerPicture.removeEventListener('transitionend', allowTransition);
    }

    function bind() {
        bindResize();
        bindNavigation();
        bindTransition();
    }

    function unbind() {
        unbindResize();
        unbindNavigation();
        unbindTransition();
    }

    function stopAutoPlay() {
        if (timer) {
            clearInterval(timer);
        }

        timer = null;
    }

    function resetInterval() {
        if (timer) {
            clearInterval(timer);
            timer = setInterval(autoPlay, 7000);
        }
    }

    function init() {
        if (param.autoplay && $containerText.length > 1) {
            timer = setInterval(autoPlay, 7000);
        }

        refreshActiveDot();
        bind();
        refreshHeightOfCarousel();
    }

    init();

    return function destroy() {
        unbind();
        stopAutoPlay();
    };
});
